// extracted by mini-css-extract-plugin
module.exports = {"pendingRequestSection":"pendingRequest_pendingRequestSection__2UVSM","responsiveTable":"pendingRequest_responsiveTable__LZHix","customeTable":"pendingRequest_customeTable__1f2sl"};